export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading text-background-50 font-bold">
                51漫画网
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              51漫画网提供官方安全入口，涵盖51漫画网页版、51漫画网址及51漫画官网版，是漫迷首选的在线阅读平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/hot-blood" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">热血漫画</Link>
              <Link to="/category/romance" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">恋爱漫画</Link>
              <Link to="/category/fantasy" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">奇幻漫画</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门推荐</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/article/1" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">斗破苍穹</Link>
              <Link to="/article/8" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">诡秘之主</Link>
              <Link to="/article/2" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">完美世界</Link>
              <Link to="/article/4" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">全职高手</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">品牌介绍</Link>
              <a href="/about#contact" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">联系我们</a>
              <a href="/about#faq" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">常见问题</a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 51漫画网 51manhua.com 版权所有 | 本站所有漫画均来自互联网，仅供学习交流使用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}